import Accounts from "./index";

const Routes = [
    {
        path: "/",
        component: Accounts,
    },
];

export default Routes;